let GlobalApis = {
  getPhoneInputCountryCodes: {
    method: 'GET',
    uri: 'phone-input-country-codes'
  },
  uploadImage: data => ({
    method: 'POST',
    uri: 'image',
    data
  })
};
let ProductPageApi = {
  importProductFromUrl: data => ({
    method: 'POST',
    uri: 'product/import_product_from_url',
    data
  }),
  getProductLightCountries: {
    method: 'GET',
    uri: 'product/filter/countries',
    allData: true
  },
  getProductLightWarehouses: {
    method: 'GET',
    uri: 'product/form/warehouses',
    allData: true
  },
  getWarehouseCountries: params => ({
    method: 'GET',
    uri: ['product/form/countries/', params].join('')
  }),
  getWarehouseAdvertisers: params => ({
    method: 'GET',
    uri: ['product/form/advertisers/', params].join('')
  }),
  getProductLightAdvertisers: {
    method: 'GET',
    uri: 'product/form/advertisers',
    allData: true
  },
  getFilteredProducts(data, query) {
    return {
      method: 'POST',
      uri: ['product/filtered_products', query].join(''),
      data
    };
  },
  createProduct(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['product/create_product', query].join(''),
      data
    };
  },
  duplicateProduct(data, params, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['product/duplicate_product/', params, query].join(''),
      data
    };
  },
  updateProduct(data, params, query = '?show=10') {
    return {
      method: 'PUT',
      uri: ['product/', params, query].join(''),
      data,
      allData: true
    };
  },
  softDeleteProduct(data, params, query = '?show=10') {
    return {
      method: 'DELETE',
      uri: ['product/', params, query].join(''),
      data,
      allData: true
    };
  },
  getInventoryFormProductCountries(params) {
    return {
      method: 'GET',
      uri: ['product/product_details/inventory/countries/', params].join('')
    };
  },
  getProductInventories(params, query) {
    return {
      method: 'GET',
      uri: ['product/product_details/inventory/', params, query].join(''),
      allData: true
    };
  },
  createProductInventory(data, params, query = '?show=5') {
    return {
      method: 'POST',
      uri: ['product/product_details/inventory/', params, query].join(''),
      data,
      allData: true
    };
  },
  softDeleteProductInventory(params, query = '?show=5') {
    return {
      method: 'DELETE',
      uri: ['product/product_details/inventory/', params, query].join('')
    };
  },
  getProductInventoryHistory(params, query) {
    return {
      method: 'GET',
      uri: ['product/product_details/inventory_history/', params, query].join(''),
      allData: true
    };
  },
  getProductInventoryOverview(params, query) {
    return {
      method: 'POST',
      uri: ['product/product_details/inventory_overview/', params, query].join(''),
      allData: true
    };
  },
  getInventoryFormProductVariations(params, query) {
    return {
      method: 'GET',
      uri: ['product/product_details/inventory/variations/', params, query].join('')
    };
  },
  deleteInventoryHistory(params, query = '?show=10') {
    return {
      method: 'DELETE',
      uri: ['inventory/', params, query].join('')
    };
  }
};
let CodOfferApi = {
  create(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['cod-offer', query].join(''),
      data
    };
  },
  duplicate(data, params, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['duplicate-cod-offer/', params, query].join(''),
      data
    };
  },
  update(data, params, query = '?show=10') {
    return {
      method: 'PUT',
      uri: ['cod-offer/', params, query].join(''),
      data
    };
  },
  softDelete(data, params, query = '?show=10') {
    return {
      method: 'DELETE',
      uri: ['cod-offer/', params, query].join(''),
      data
    };
  },
  getFiltered(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['cod-offer-filter', query].join(''),
      data
    };
  }
};
let PrepaidOfferApi = {
  create(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['prepaid-offer', query].join(''),
      data
    };
  },
  duplicate(data, params, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['duplicate-card-offer/', params, query].join(''),
      data
    };
  },
  update(data, params, query = '?show=10') {
    return {
      method: 'PUT',
      uri: ['prepaid-offer/', params, query].join(''),
      data
    };
  },
  softDelete(data, params, query = '?show=10') {
    return {
      method: 'DELETE',
      uri: ['prepaid-offer/', params, query].join(''),
      data
    };
  },
  getFiltered(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['prepaid-offer-filter', query].join(''),
      data
    };
  }
};
let OfferPageApi = {
  getFilterAdvertisers: {
    method: 'GET',
    uri: 'offer-page-filter-advertisers'
  },
  requestOfferReview(data, params, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['offer-request/', params, query].join(''),
      data
    };
  },
  deleteSalePage(params, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['sale-page/', params, query].join('')
    };
  },
  generateSalePage(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['sale-page-generate', query].join(''),
      data
    };
  },
  generatePreSellPage(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['generate-pre-sell-page', query].join(''),
      data
    };
  },
  deleteGeneratedPreSellPage(params, query = '?show=10') {
    return {
      method: 'DELETE',
      uri: ['generate-pre-sell-page/', params, query].join('')
    };
  },
  getCodOfferLightCountries: {
    method: 'GET',
    uri: 'cod-offer-light-countries',
    allData: true
  },
  getPrePaidOfferLightCountries: {
    method: 'GET',
    uri: 'prepaid-offer-light-countries',
    allData: true
  },
  getProductLightAvailableCountries(params) {
    return {
      method: 'GET',
      uri: ['product-light-available-countries/', params].join('')
    };
  },
  getOfferLightProducts: {
    method: 'GET',
    uri: 'offer-light-products',
    allData: true
  },
  getOfferFormSelectUsers: {
    method: 'GET',
    uri: 'offer-form-select-light-users'
  },
  getOfferDefaultDomains() {
    return {
      method: 'GET',
      uri: 'offer-default-domains',
      allData: true
    };
  },
  getUserSalePagesByOffer(params, query = '?show=10') {
    return {
      method: 'GET',
      uri: ['user-sale-page-by-offer/', params, query].join('')
    };
  },
  getUserPreSellPagesByOffer(params, query = '?show=10') {
    return {
      method: 'GET',
      uri: ['generate-pre-sell-page/', params, query].join('')
    };
  },
  OfferAllowedInternetDomains(params, query = '?show=10') {
    return {
      method: 'GET',
      uri: ['offer-allowed-internal-domains/', params, query].join('')
    };
  },
  OfferAllowedExternalDomains(params, query = '?show=10') {
    return {
      method: 'GET',
      uri: ['offer-allowed-external-domains/', params, query].join('')
    };
  },
  getGeneratedPreSellPage: params => ({
    method: 'GET',
    uri: ['generate-pre-sell-page/', params].join('')
  }),
  getOfferShippingCountries: {
    method: 'GET',
    uri: 'offer-shipping-countries'
  }
};
let RegisterPageApi = {
  getAllLightCountries: {
    method: 'GET',
    uri: 'light-countries'
  }
};
let SettingsPageApi = {
  getAllLightCountries: {
    method: 'GET',
    uri: 'light-countries'
  },
  getFormProducts: {
    method: 'GET',
    uri: 'domains/form/products'
  }
};
let UsersPageApi = {
  getPermissions: {
    method: 'GET',
    uri: 'permission'
  },
  updateRoles: (data, roleId) => ({
    method: 'POST',
    uri: 'user/account/manage_roles/update_roles_permissions/' + roleId,
    data
  }),
  getPlans: {
    method: 'GET',
    uri: 'user/account/manage_plans/plans'
  },
  updatePlans: (data, planId) => ({
    method: 'POST',
    uri: 'user/account/manage_plans/update_plan_permissions/' + planId,
    data
  }),
  updateRoleUsers: (data, roleId) => ({
    method: 'POST',
    uri: 'user/account/manage_roles/update_role_users_permissions/' + roleId,
    data
  }),
  getRoleManagerRoles: {
    method: 'GET',
    uri: 'user/account/manage_roles/roles'
  },
  getRoleManagerPermissions: {
    method: 'GET',
    uri: 'role-manager-light-permissions'
  },
  getAllLightCountries: {
    method: 'GET',
    uri: 'user-filter-select-light-countries'
  },
  addPermissionsToRoles(data) {
    return {
      method: 'POST',
      uri: 'add-permission-to-role',
      data
    };
  },
  removePermissionsFromRoles(data) {
    return {
      method: 'POST',
      uri: 'remove-permission-from-role',
      data
    };
  },
  addPermissionsToRoleUsers(data) {
    return {
      method: 'POST',
      uri: 'add-permission-to-role-user',
      data
    };
  },
  removePermissionsFromRoleUsers(data) {
    return {
      method: 'POST',
      uri: 'remove-permission-from-role-user',
      data
    };
  },
  getFilteredUsers: (data, query = '?show=10&page=1') => {
    return {
      method: 'POST',
      uri: ['user/account/manage_users/filtered_users', query].join(''),
      data
    };
  },
  createUser: (data, query = '?show=10&page=1') => {
    return {
      method: 'POST',
      uri: ['user/account/manage_users/create_user', query].join(''),
      data
    };
  },
  duplicateUser: (params, data, query = '?show=10&page=1') => {
    return {
      method: 'POST',
      uri: ['user/account/manage_users/duplicate_user/', params, query].join(''),
      data
    };
  },
  updateUser: (params, data, query = '?show=10&page=1') => {
    return {
      method: 'PUT',
      uri: ['user/account/manage_users/edit_user/', params, query].join(''),
      data
    };
  },
  setUserStatus: (data, query = '?show=10&page=1') => {
    return {
      method: 'POST',
      uri: ['user/account/manage_users/multiple_edit_status', query].join(''),
      data
    };
  }
};
let WarehousePageApi = {
  getAllLightCountries: {
    method: 'GET',
    uri: 'light-countries',
    allData: true
  },
  getLightWarehouses: {
    method: 'GET',
    uri: 'light-warehouses'
  },
  createWarehouse: (data, query) => ({
    method: 'POST',
    uri: ['warehouse', query].join(''),
    data
  }),
  updateWarehouse: (params, data, query) => ({
    method: 'PUT',
    uri: ['warehouse/', params, query].join(''),
    data
  }),
  getWarehouses: {
    method: 'GET',
    uri: 'warehouse'
  },
  getWarehouseCallAgents: {
    method: 'GET',
    uri: 'warehouse-call-agents'
  },
  getActiveWarehouses: {
    method: 'GET',
    uri: 'warehouse-active'
  },
  getFilteredWarehouses: (data, query) => ({
    method: 'POST',
    uri: ['warehouse/filtered', query].join(''),
    data
  }),
  setWarehousesStatus: data => ({
    method: 'POST',
    uri: 'warehouse/multiple_warehouse_status_change',
    data
  }),
  getWarehousePrices: {
    method: 'GET',
    uri: 'warehouse-price'
  },
  getLightWarehouseProducts: params => ({
    method: 'GET',
    uri: ['light-warehouse-products/', params].join('')
  }),
  getCountriesWithWarehouses: {
    method: 'GET',
    uri: 'warehouse/filter/countries'
  },
  FORM: {
    USERS: {
      method: 'GET',
      uri: 'warehouse/form/users'
    }
  }
};
let ProductSalePageApi = {
  createProductSalePageWithAi: (data, query) => ({
    method: 'POST',
    uri: ['product_sale_page/form/create_with_ai', query].join(''),
    data
  }),
  getBlocksFromApi: data => ({
    method: 'POST',
    uri: 'product_sale_page/form/generate_blocks/ai',
    data
  }),
  updateBlocksUsingApi: data => ({
    method: 'PUT',
    uri: 'product_sale_page/form/generate_blocks/ai',
    data
  }),
  createProductSalePage: (data, query) => ({
    method: 'POST',
    uri: ['product_sale_page/form/create', query].join(''),
    data
  }),
  updateProductSalePage: (params, data, query) => ({
    method: 'PUT',
    uri: ['product_sale_page/form/update/', params, query].join(''),
    data
  }),
  getFilterProducts: {
    method: 'GET',
    uri: 'product_sale_page/filter/products'
  },
  getFilteredSalePages: query => ({
    method: 'POST',
    uri: ['product_sale_page', query].join('')
  }),
  duplicateSalePage: (params, query = '?show=10') => ({
    method: 'GET',
    uri: ['product_sale_page/duplicate/', params, query].join('')
  }),
  deleteSalePage: (params, query = '?show=10') => ({
    method: 'DELETE',
    uri: ['product_sale_page/', params, query].join('')
  }),
  getFormSalePage: params => ({
    method: 'GET',
    uri: ['product_sale_page/form/sale-page', params].join('/')
  }),
  getFilterUsers: {
    method: 'GET',
    uri: 'product_sale_page/filter/users'
  },
  getFilterCountries: {
    method: 'GET',
    uri: 'product_sale_page/filter/countries'
  },
  getFormDomains: {
    method: 'GET',
    uri: 'product_sale_page/form/domains'
  },
  getFormLayout: storeId => ({
    method: 'GET',
    uri: ['product_sale_page/form/layout/', storeId].join('')
  }),
  getFilterDomains: {
    method: 'GET',
    uri: 'product_sale_page/filter/domains'
  },
  getFormProducts: {
    method: 'GET',
    uri: 'product_sale_page/form/products'
  },
  getFormCountries: params => ({
    method: 'GET',
    uri: ['product_sale_page/form/countries/', params].join('')
  }),
  formShippingCountries: {
    method: 'GET',
    uri: 'product_sale_page/form/shipping_countries'
  },
  currencies: {
    method: 'GET',
    uri: 'product_sale_page/form/currencies'
  },
  getCrossSellProducts: params => ({
    method: 'GET',
    uri: ['product_sale_page/form/cross-sells-products/', params].join('')
  })
};
let SalePageProtoApi = {
  getFormSalePage: params => ({
    method: 'GET',
    uri: ['sale_page/original/form/sale_page', params].join('/')
  }),
  getAllLightOffers: params => ({
    method: 'POST',
    uri: ['sale_page/original/filter/offers/', params].join('')
  }),
  duplicateSalePage: (params, data, query = '?show=10') => ({
    method: 'POST',
    uri: ['sale_page/original/duplicate/', params, query].join(''),
    data
  }),
  deleteSalePage: (params, data, query = '?show=10') => ({
    method: 'POST',
    uri: ['sale_page/original/delete', params, query].join(''),
    data
  }),
  getFilteredSalePages: (data, query = '?show=10') => ({
    method: 'POST',
    uri: ['sale_page/original/filtered', query].join(''),
    data
  }),
  getFilterUsers: {
    method: 'GET',
    uri: 'sale_page/original/filter/users'
  },
  updateSalePage: (params, data, query = '?show=10') => ({
    method: 'POST',
    uri: ['sale_page/original/update/', params, query].join(''),
    data
  }),
  getLightDomains: {
    method: 'GET',
    uri: 'sale_page/original/form/domains'
  },
  getFilterCountries: {
    method: 'GET',
    uri: 'sale_page/original/filter/country'
  },
  getFilterDomains: {
    method: 'GET',
    uri: 'sale_page/original/filter/domain'
  }
};
let SalePageInstanceApi = {
  getFormSalePage: params => ({
    method: 'GET',
    uri: ['sale_page/generated/form/sale_page', params].join('/')
  }),
  getAllLightOffers: params => ({
    method: 'POST',
    uri: ['sale_page/generated/filter/offers/', params].join('')
  }),
  duplicateSalePage: (params, data, query = '?show=10') => ({
    method: 'POST',
    uri: ['sale_page/generated/duplicate/', params, query].join(''),
    data
  }),
  deleteSalePage: (params, data, query = '?show=10') => ({
    method: 'POST',
    uri: ['sale_page/generated/delete/', params, query].join(''),
    data
  }),
  getFilteredSalePages: (data, query = '?show=10') => ({
    method: 'POST',
    uri: ['sale_page/generated/filtered', query].join(''),
    data
  }),
  getFilterUsers: {
    method: 'GET',
    uri: 'sale_page/generated/filter/users'
  },
  updateSalePage: (params, data, query = '?show=10') => ({
    method: 'POST',
    uri: ['sale_page/generated/update/', params, query].join(''),
    data
  }),
  getLightDomains: {
    method: 'GET',
    uri: 'sale_page/generated/form/domains'
  },
  getFilterCountries: {
    method: 'GET',
    uri: 'sale_page/generated/filter/country'
  },
  getFilterDomains: {
    method: 'GET',
    uri: 'sale_page/generated/filter/domain'
  }
};
let SalePagePageApi = {
  getBlocksFromApi: data => ({
    method: 'POST',
    uri: 'sale_page/form/generate_blocks/ai',
    data
  }),
  updateBlocksUsingApi: data => ({
    method: 'PUT',
    uri: 'sale_page/form/generate_blocks/ai',
    data
  }),
  allowedCountriesAddonCountries: {
    method: 'GET',
    uri: 'product_sale_page/form/addons/allow_countries/countries'
  },
  createSalePage(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['sale_page', query].join(''),
      data
    };
  },
  updateSalePage(params, data, query = '?show=10', allData = false) {
    return {
      method: 'PUT',
      uri: ['sale-page/', params, query].join(''),
      data,
      allData
    };
  },
  deleteSalePages(params, data, allData = false) {
    return {
      method: 'POST',
      uri: ['sale-page/', params].join(''),
      data,
      allData
    };
  },
  getFilteredSalePage(data, query = '?show=10', allData) {
    return {
      method: 'POST',
      uri: ['sale-page-user', query].join(''),
      data,
      allData
    };
  },
  FormLightOffers: {
    method: 'GET',
    uri: 'sale_page/form/offers'
  },
  getAllOffers: {
    method: 'GET',
    uri: 'sale-page-offers',
    allData: true
  },
  getSalePageFormCrossSellOffers: params => ({
    method: 'GET',
    uri: ['sale_page/form/cross_sell_offers/', params].join('')
  })
};
let LeadPageApi = {
  confirmOrder(data, params, query = '', asArray = false) {
    return {
      method: 'POST',
      uri: ['order-confirm/', params, query].join(''),
      data,
      allData: true,
      asArray
    };
  },
  editLead(params, data, query = '') {
    return {
      method: 'POST',
      uri: ['lead-edit/', params, query].join(''),
      data
    };
  },
  getOrderCountries: {
    method: 'GET',
    uri: 'order-filter-select-light-countries',
    allData: true
  },
  getOrderProducts: {
    method: 'GET',
    uri: 'order-product',
    allData: true
  }
};
let InventoryOverViewPageApi = {
  getFilteredInventoryOverview(data, query) {
    return {
      method: 'POST',
      uri: ['inventory_overview', query].join(''),
      data
    };
  },
  getInventoryOverviewLightProducts: {
    method: 'GET',
    uri: 'inventory_overview/filter/products',
    allData: true
  },
  getInventoryOverviewLightWarehouses: {
    method: 'GET',
    uri: 'inventory_overview/filter/warehouses',
    allData: true
  },
  getInventoryOverviewLightCountries: {
    method: 'GET',
    uri: 'inventory_overview/filter/countries',
    allData: true
  }
};
let TestedOrdersPageApi = {
  getFilteredTestOrders(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['test-order-filter', query].join(''),
      data
    };
  },
  sendOrderToWarehouse(data) {
    return {
      method: 'POST',
      uri: 'send-orders-to-warehouse',
      data,
      allData: true
    };
  },
  getTestOrderProducts: {
    method: 'GET',
    uri: 'test-order-product',
    allData: true
  },
  getTestOrderCountries: {
    method: 'GET',
    uri: 'test-order-country',
    allData: true
  },
  getTestOrderOffers: {
    method: 'GET',
    uri: 'test-order-offer',
    allData: true
  },
  getTestOrderUsers: {
    method: 'GET',
    uri: 'test-order-user',
    allData: true
  },
  getTestOrderWarehouses: {
    method: 'GET',
    uri: 'test-order-warehouse',
    allData: true
  },
  getTestOrderCallAgents: {
    method: 'GET',
    uri: 'test-order-call-agent',
    allData: true
  }
};
let OrderPageApi = {
  getExelSelectedOrder: query => ({
    method: 'GET',
    uri: 'order/export_orders' + query
  }),
  importOrders: data => ({
    method: 'POST',
    uri: 'order/import',
    data,
    serialize: false
  }),
  getImportOrdersSalePages: {
    method: 'GET',
    uri: 'order/import/sale_pages'
  },
  getImportOrdersCountries: {
    method: 'GET',
    uri: 'order/import/countries'
  },
  changeOrderAgent: (query, data) => ({
    method: 'POST',
    uri: ['order/change_order_call_agent', query].join(''),
    data
  }),
  changeOrderStatus: (data, query) => ({
    method: 'POST',
    uri: ['order/multiple_order_status_change', query].join(''),
    data
  }),
  addCallStatus: (data, query) => ({
    method: 'POST',
    uri: ['order/multiple_order_call_status_change', query].join(''),
    data
  }),
  cancelOrder(data, params, query = '') {
    return {
      method: 'POST',
      uri: ['order-cancel/', params, query].join(''),
      data,
      allData: true
    };
  },
  getFilteredOrders(data, query = '?show=10&page=1') {
    return {
      method: 'POST',
      uri: ['order/filtered_orders', query].join(''),
      data
    };
  },
  editOrder(params, data, query = '?show=10&page=1') {
    return {
      method: 'POST',
      uri: ['order/edit_order_details/edit_order/', params, query].join(''),
      data
    };
  },
  showOrderDetails: (params, query = '?show=10&page=1') => ({
    method: 'GET',
    uri: ['order/edit_order_details/', params, query].join('')
  }),
  getOrderCalls(params, query = '?show=10&page=1') {
    return {
      method: 'GET',
      uri: ['order/edit_order_details/order_calls/', params, query].join('')
    };
  },
  addOrderCall(data, params, query = '?show=10&page=1') {
    return {
      method: 'POST',
      uri: ['order/edit_order_details/add_order_call/', params, query].join(''),
      data
    };
  },
  addOrderPrivateNote(data, params, query = '?show=5&page=1') {
    return {
      method: 'POST',
      uri: ['order/edit_order_details/add_order_note/', params, query].join(''),
      data
    };
  },
  getOrderPrivateNotes(params, query = '?show=5&page=1') {
    return {
      method: 'GET',
      uri: ['order/edit_order_details/order_notes/', params, query].join('')
    };
  },
  getOrderCountries: {
    method: 'GET',
    uri: 'order/filter/countries',
    allData: true
  },
  getOrderOffers: {
    method: 'GET',
    uri: 'order/filter/offers',
    allData: true
  },
  getOrderUsers: {
    method: 'GET',
    uri: 'order/filter/users',
    allData: true
  },
  getOrderProducts: {
    method: 'GET',
    uri: 'order/filter/products',
    allData: true
  },
  getOrderWarehouses: {
    method: 'GET',
    uri: 'order/filter/warehouses'
  },
  getOrderCallAgents: {
    method: 'GET',
    uri: 'order/filter/call_agents',
    allData: true
  },
  getOrderSelectStatesByCountry(params) {
    return {
      method: 'GET',
      uri: ['order/edit_order_details/regions', params].join('/')
    };
  },
  getOrderSelectCitiesByState(params) {
    return {
      method: 'GET',
      uri: ['order/edit_order_details/cities', params].join('/')
    };
  },
  getOrderDetailsCountries: {
    method: 'GET',
    uri: 'order/edit_order_details/countries'
  },
  sendToWarehouseNetwork: (params, query) => ({
    method: 'PATCH',
    uri: ['order/edit_order_details/send_to_warehouse_network/', params, query].join('')
  }),
  sendToSheets: (params, query) => ({
    method: 'PATCH',
    uri: ['order/edit_order_details/send_to_sheets/', params, query].join('')
  })
};
let PendingOrdersPageApi = {
  generatePayoutInvoices(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['generate-payout-invoices', query].join(''),
      data
    };
  },
  generateRemittanceInvoices(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['generate-remittance-invoices', query].join(''),
      data
    };
  },
  generateExpensesInvoices(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['generate-expenses-invoices', query].join(''),
      data
    };
  },
  generateCommissionInvoices(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['generate-commission-invoices', query].join(''),
      data
    };
  },
  getInvoiceAllOrders: (data, query = '?show=10') => ({
    method: 'POST',
    uri: ['invoice-all-orders', query].join(''),
    data
  }),
  getFilterAdvertisers: {
    method: 'GET',
    uri: 'pending-invoice-filter-advertisers'
  },
  getInvoicedOrdersSellers: {
    method: 'GET',
    uri: 'invoice-orders-light-sellers'
  },
  getInvoicedOrdersWarehouses: {
    method: 'GET',
    uri: 'invoice-orders-light-warehouses'
  }
};
let InvoicePageApi = {
  removeOrderFromPayoutInvoice(params, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['invoice/payout/details/remove_order/', params, query].join('')
    };
  },
  removeOrderFromCommissionInvoice(params, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['invoice/commission/details/remove_order/', params, query].join('')
    };
  },
  removeOrderFromRemittanceInvoice(params, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['invoice/remittance/details/remove_order/', params, query].join('')
    };
  },
  removeOrderFromExpensesInvoice(params, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['invoice/expenses/details/remove_order/', params, query].join('')
    };
  },
  removeOrderFromInvoice(params, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['invoice/payout/remove-order/', params, query].join('')
    };
  },
  getPayoutInvoiceOrders(params, query = '?show=10') {
    return {
      method: 'GET',
      uri: ['invoice/payout/details/invoice_orders/', params, query].join('')
    };
  },
  getRemittanceInvoiceOrders(params, query = '?show=10') {
    return {
      method: 'GET',
      uri: ['invoice/remittance/details/invoice_orders/', params, query].join('')
    };
  },
  getExpensesInvoiceOrders(params, query = '?show=10') {
    return {
      method: 'GET',
      uri: ['invoice/expenses/details/invoice_orders/', params, query].join('')
    };
  },
  getCommissionInvoiceOrders(params, query = '?show=10') {
    return {
      method: 'GET',
      uri: ['invoice/commission/details/invoice_orders/', params, query].join('')
    };
  },
  payInvoices(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['pay-all-seller-invoice', query].join(''),
      data
    };
  },
  getLightSellers: {
    method: 'GET',
    uri: 'light-seller'
  },
  saveWhatsAppData(data) {
    return {
      method: 'PUT',
      uri: 'invoice/settings/other_data/whatsapp',
      data
    };
  },
  whatsAppPhoneCountries: {
    method: 'GET',
    uri: 'invoice/settings/other_data/whatsapp/countries'
  }
};
let PayoutInvoicesPageApi = {
  getInvoicesStats(data) {
    return {
      method: 'POST',
      uri: 'paid-seller-invoice',
      data
    };
  },
  getFilteredInvoices(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['seller-invoice', query].join(''),
      data
    };
  },
  deleteInvoice(data, params, query = '?show=10') {
    return {
      method: 'DELETE',
      uri: ['invoice/payout/delete/', params, query].join(''),
      data
    };
  },
  payInvoices(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['pay-seller-payout-invoice', query].join(''),
      data
    };
  },
  getReferrerReferredInvoices(params, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['referral-invoices/', params, query].join('')
    };
  }
};
let ExpensesInvoicesPageApi = {
  getInvoicesStats(data) {
    return {
      method: 'POST',
      uri: 'paid-warehouse-expenses-invoice',
      data
    };
  },
  getWarehouses() {
    return {
      method: 'GET',
      uri: 'warehouse-expenses-invoices-light-warehouses'
    };
  },
  getFilteredInvoices(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['warehouse-expenses-invoice', query].join(''),
      data
    };
  },
  payInvoices(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['pay-warehouse-expenses-invoice', query].join(''),
      data
    };
  },
  deleteInvoice(data, params, query = '?show=10') {
    return {
      method: 'DELETE',
      uri: ['invoice/expenses/delete/', params, query].join(''),
      data
    };
  }
};
let RemittanceInvoicesPageApi = {
  getInvoicesStats(data) {
    return {
      method: 'POST',
      uri: 'paid-warehouse-remittance-invoice',
      data
    };
  },
  getFilteredInvoices(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['warehouse-remittance-invoice', query].join(''),
      data
    };
  },
  getWarehouses() {
    return {
      method: 'GET',
      uri: 'warehouse-remittance-invoices-light-warehouses'
    };
  },
  payInvoices(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['pay-warehouse-remittance-invoice', query].join(''),
      data
    };
  },
  deleteInvoice(data, params, query = '?show=10') {
    return {
      method: 'DELETE',
      uri: ['invoice/remittance/delete/', params, query].join(''),
      data
    };
  }
};
let CommissionInvoicesPageApi = {
  getInvoicesStats(data) {
    return {
      method: 'POST',
      uri: 'paid-advertiser-invoice',
      data
    };
  },
  getFilteredInvoices(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['advertiser-invoice', query].join(''),
      data
    };
  },
  getAdvertisers() {
    return {
      method: 'GET',
      uri: 'commission-invoices-filter-advertisers'
    };
  },
  payInvoices(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['pay-commission-invoice', query].join(''),
      data
    };
  },
  deleteInvoice(data, params, query = '?show=10') {
    return {
      method: 'DELETE',
      uri: ['invoice/commission/delete/', params, query].join(''),
      data
    };
  }
};
let LibraryPageApi = {
  oneTimeUpload() {},
  saveSingleImage: (data, contentType, isAsync, data_model, query = '?show=10') => ({
    method: 'POST',
    uri: ['save-single-image', query].join(''),
    data,
    contentType,
    isAsync,
    data_model,
    timeout: 600000
  }),
  saveAndFetchSingleImage: (data, contentType, isAsync = false, data_model, query = '?show=10') => ({
    method: 'POST',
    uri: ['save-fetch-single-image', query].join(''),
    data,
    contentType,
    isAsync,
    data_model,
    timeout: 600000
  }),
  saveAndFetchSingleVideo: (data, contentType, isAsync = false, data_model, query = '?show=10') => ({
    method: 'POST',
    uri: ['save-fetch-single-video', query].join(''),
    data,
    contentType,
    isAsync,
    data_model,
    timeout: 3600000
  }),
  saveSingleVideo: (data, contentType, isAsync, data_model, query = '?show=10') => ({
    method: 'POST',
    uri: ['save-single-video', query].join(''),
    data,
    contentType,
    isAsync,
    data_model,
    timeout: 3600000
  }),
  getUserImages(query) {
    return {
      method: 'GET',
      uri: ['user/image', query].join('')
    };
  },
  storeSingleVideo(data, query = '?show=10', options) {
    return {
      method: 'POST',
      uri: ['store-single-video', query].join(''),
      data,
      ...options
    };
  },
  getUserVideos(query, allData = false) {
    return {
      method: 'GET',
      uri: 'user/video' + query,
      allData
    };
  },
  CheckAndDeleteImage(params, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['check-delete-image/', params, query].join(''),
      allData: true
    };
  },
  CheckAndDeleteVideo(params, query = '') {
    return {
      method: 'POST',
      uri: ['check-delete-video/', params, query].join(''),
      allData: true
    };
  },
  deleteImage(params, query) {
    return {
      method: 'DELETE',
      uri: ['image/', params, query].join('')
    };
  },
  deleteVideo(params, query) {
    return {
      method: 'DELETE',
      uri: ['video/', params, query].join('')
    };
  }
};
let OverViewPageApi = {
  visitsCount: query => ({
    method: 'GET',
    uri: ['overview/visits', query].join('')
  }),
  todayVisitsCount: query => ({
    method: 'GET',
    uri: ['overview/visits/today', query].join('')
  }),
  yesterdayVisitsCount: query => ({
    method: 'GET',
    uri: ['overview/visits/yesterday', query].join('')
  }),
  thisMonthVisitsCount: query => ({
    method: 'GET',
    uri: ['overview/visits/current_month', query].join('')
  }),
  lastMonthVisitsCount: query => ({
    method: 'GET',
    uri: ['overview/visits/previous_month', query].join('')
  }),
  topOffersEarnings: {
    method: 'GET',
    uri: 'overview/top_offer_earnings'
  },
  topProductSales: query => ({
    method: 'GET',
    uri: 'overview/top_product_sales' + query
  }),
  topCountryEarnings: {
    method: 'GET',
    uri: 'overview/top_country_earnings'
  },
  topCountrySales: query => ({
    method: 'GET',
    uri: 'overview/top_country_sales' + query
  }),
  orderDeliveredEarnings: {
    method: 'GET',
    uri: 'overview/delivered_order_earnings'
  },
  orderDeliveredSales: query => ({
    method: 'GET',
    uri: 'overview/delivered_orders_sales' + query
  }),
  orderEarnings: {
    method: 'GET',
    uri: 'overview/order_earnings_overview'
  },
  orderSales: query => ({
    method: 'GET',
    uri: 'overview/order_sales_overview' + query
  }),
  orderCount: query => ({
    method: 'GET',
    uri: 'overview/order_count' + query
  }),
  filterStores: {
    method: 'GET',
    uri: 'overview/filter/domains'
  }
};
let TrendingPageApi = {
  getTopOffersTrendingEarnings(data) {
    return {
      method: 'POST',
      uri: 'top-offer-earnings-trending',
      data
    };
  },
  getTopCountriesTrendingEarnings(data) {
    return {
      method: 'POST',
      uri: 'top-country-earnings-trending',
      data
    };
  },
  TrendingLastFiveReleasedOffer: {
    method: 'GET',
    uri: 'trending-last-five-offers'
  },
  TopFiveSellersOfTheMonth: {
    method: 'GET',
    uri: 'five-top-seller-earnings-trending'
  }
};
let HomePageApi = {
  dontShowTutorial(params) {
    return {
      method: 'GET',
      uri: ['dont-show-tutorial/', params].join('')
    };
  },
  showTutorialLater(params) {
    return {
      method: 'GET',
      uri: ['show-tutorial-later/', params].join('')
    };
  }
};
let ExternalRequestsApi = {
  GetClientGeoLocation(baseURL, query = '') {
    return {
      baseURL,
      method: 'GET',
      uri: '' + query,
      external: true
    };
  }
};
let CallCenterPageApi = {
  GetAllLightWarehouses: {
    method: 'GET',
    uri: 'all-light-warehouses'
  },
  GetFilterLightCountries: {
    method: 'GET',
    uri: 'call_center/filter/countries'
  },
  GetFilterLightWarehouses: {
    method: 'GET',
    uri: 'call_center/filter/warehouses'
  },
  CreateCallAgent(data, query) {
    return {
      method: 'POST',
      uri: ['call_center/form', query].join(''),
      data,
      asArray: true
    };
  },
  editCallAgent(data, params, query) {
    return {
      method: 'PUT',
      uri: ['call_center/form/', params, query].join(''),
      data,
      asArray: true
    };
  },
  generalAssignProducts(data, query) {
    return {
      method: 'POST',
      uri: ['call_center/assign_agent_products', query].join(''),
      data
    };
  },
  assignProductsToCallAgents(data, query) {
    return {
      method: 'POST',
      uri: ['call_center/product_assign', query].join(''),
      data
    };
  },
  filterCallAgent(data, query) {
    return {
      method: 'POST',
      uri: ['call_center/filter/call_agent', query].join(''),
      data
    };
  },
  getLightWarehouseProducts(params) {
    return {
      method: 'GET',
      uri: ['call_center/products', params].join(params ? '/' : '')
    };
  },
  setCallAgentStatus: (data, query = '?show=10') => ({
    method: 'POST',
    uri: ['call_center/status_change', query].join(''),
    data
  })
};
let AdvertiserPageApi = {
  getLightWarehouses: {
    method: 'GET',
    uri: 'advertiser/filter/warehouses'
  },
  getLightCountries: {
    method: 'GET',
    uri: 'advertiser/filter/countries'
  },
  createAdvertiser(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['advertiser/form', query].join(''),
      data
    };
  },
  updateAdvertiser(data, params, query = '?show=10') {
    return {
      method: 'PUT',
      uri: ['advertiser/form', params, query].join(''),
      data
    };
  },
  duplicateAdvertiser(data, params, query = '?show=10') {
    return {
      method: 'PUT',
      uri: ['advertiser/duplicate/', params, query].join(''),
      data
    };
  },
  filterAdvertiser(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['advertiser/filter', query].join(''),
      data
    };
  },
  updateAdvertiserStatus(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['advertiser/edit/status', query].join(''),
      data
    };
  }
};
let SaleReportPageApi = {
  getUserOrdersCountry: {
    method: 'GET',
    uri: 'sale_report/filter/country'
  },
  getUserOrdersOffers: {
    method: 'GET',
    uri: 'sale_report/filter/offer'
  },
  getUserOrdersSellers: {
    method: 'GET',
    uri: 'sale_report/filter/seller'
  },
  getUserOrdersCallAgent: {
    method: 'GET',
    uri: 'sale_report/filter/call-agent'
  },
  getUserOrdersProducts: {
    method: 'GET',
    uri: 'sale_report/filter/product'
  },
  getSaleReportChart(data, query) {
    return {
      method: 'POST',
      uri: ['sale_report/chart', query].join(''),
      data
    };
  },
  getReferrerSaleReport(data, query = '?show=10') {
    console.log('getReferrerSaleReport query', query);
    return {
      method: 'POST',
      uri: ['sale_report/referrer', query].join(''),
      data
    };
  },
  getSalePageSaleReport(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['sale_report/sale_page', query].join(''),
      data
    };
  },
  getCountrySaleReport(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['sale_report/country', query].join(''),
      data
    };
  },
  getSellerSaleReport(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['sale_report/seller', query].join(''),
      data
    };
  },
  getWarehouseSaleReport(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['sale_report/warehouse', query].join(''),
      data
    };
  },
  getManagerSaleReport(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['sale_report/manager', query].join(''),
      data
    };
  },
  getProductSaleReport(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['sale_report/product', query].join(''),
      data
    };
  },
  getOfferSaleReport(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['sale_report/offer', query].join(''),
      data
    };
  },
  getCallAgentSaleReport(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['sale_report/call_agent', query].join(''),
      data
    };
  }
};
let SellerPageApi = {
  getCountriesWithSellers: {
    method: 'GET',
    uri: 'sellers/countries'
  },
  getActiveManagers: {
    method: 'GET',
    uri: 'sellers/managers'
  },
  getFilteredSellers(query) {
    return {
      method: 'GET',
      uri: ['sellers/filtered', query].join('')
    };
  },
  setSellerStatus: (data, query = '?show=10') => {
    return {
      method: 'POST',
      uri: ['sellers/status', query].join(''),
      data
    };
  },
  setSellerManager(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['sellers/manager', query].join(''),
      data
    };
  }
};
let DomainPageApi = {
  getDomainFormLightCountries: {
    method: 'GET',
    uri: 'domains/form/countries'
  },
  enableDomainWalletPayment: (data, params, query = '?show=10') => ({
    method: 'GET',
    uri: ['domains/enable_wallet_payment/', params, query].join(''),
    data
  }),
  disableDomainWalletPayment: (data, params, query = '?show=10') => ({
    method: 'GET',
    uri: ['domains/disable_wallet_payment/', params, query].join(''),
    data
  }),
  createDomain(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['domains', query].join(''),
      data
    };
  },
  saveDomain(data, params, query = '?show=10') {
    return {
      method: 'PUT',
      uri: ['domains/', params, query].join(''),
      data
    };
  },
  deleteDomain(data, params, query = '?show=10') {
    return {
      method: 'DELETE',
      uri: ['domains/', params, query].join(''),
      data
    };
  },
  getUserDomains(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['domains/filtered', query].join(''),
      data
    };
  },
  stores: {
    method: 'GET',
    uri: 'domains/form/stores'
  }
};
let AccountingPageApi = {
  getUserOrdersSellers: {
    method: 'GET',
    uri: 'accounting/filter/sellers'
  },
  getUserOrdersProducts: {
    method: 'GET',
    uri: 'accounting/filter/products'
  },
  getUserOrdersCountry: {
    method: 'GET',
    uri: 'accounting/filter/countries'
  },
  getUserOrdersCallAgent: {
    method: 'GET',
    uri: 'accounting/filter/call_agents'
  },
  getAccountingChart: data => ({
    method: 'POST',
    uri: 'accounting/chart',
    data
  }),
  getCountryAccounting: (data, query = '?show=10') => ({
    method: 'POST',
    uri: ['accounting/country', query].join(''),
    data
  }),
  getWarehouseAccounting: (data, query = '?show=10') => ({
    method: 'POST',
    uri: ['accounting/warehouse', query].join(''),
    data
  }),
  getSellerAccounting: (data, query = '?show=10') => ({
    method: 'POST',
    uri: ['accounting/seller', query].join(''),
    data
  }),
  getProductAccounting: (data, query = '?show=10') => ({
    method: 'POST',
    uri: ['accounting/product', query].join(''),
    data
  }),
  getManagerAccounting: (data, query = '?show=10') => ({
    method: 'POST',
    uri: ['accounting/manager', query].join(''),
    data
  })
};
let NotificationPageApi = {
  getFormUsers: {
    method: 'GET',
    uri: 'notification/form/users'
  },
  createNotification: (data, query = '?show=10') => {
    return {
      method: 'POST',
      uri: ['notification', query].join(''),
      data
    };
  },
  unreadNotificationCount: {
    method: 'GET',
    uri: 'notifications/count-unread-notification'
  },
  getExtendedAudienceNotifications(query = '?show=10') {
    return {
      method: 'GET',
      uri: ['notifications/notification-extended', query].join('')
    };
  },
  getAudienceNotifications: (query = '?show=10') => ({
    method: 'GET',
    uri: ['notification', query].join('')
  }),
  readAllNotifications: {
    method: 'GET',
    uri: 'notifications/read-notification'
  }
};
let PaymentSettings = {
  getUserPaymentDetails: {
    method: 'GET',
    uri: 'settings/payment_data/user-payment-info'
  },
  getBankDetails: {
    method: 'GET',
    uri: 'settings/payment_data/bank_detail'
  },
  getPayoneerDetails: {
    method: 'GET',
    uri: 'settings/payment_data/payoneer'
  },
  saveBankInfo(data) {
    return {
      method: 'POST',
      uri: 'settings/payment_data/bank_detail',
      data
    };
  },
  savePayoneerInfo(data) {
    return {
      method: 'POST',
      uri: 'settings/payment_data/payoneer',
      data
    };
  }
};
let PaymentProcessorsSettings = {
  addStripeAccount: data => ({
    method: 'POST',
    uri: 'settings/payment_processors',
    data
  }),
  saveStripeAccount: (data, params) => ({
    method: 'PUT',
    uri: ['settings/payment_processors', params].join('/'),
    data
  }),
  deleteStripeAccount: params => ({
    method: 'DELETE',
    uri: ['settings/payment_processors', params].join('/')
  }),
  activateStripeAccount: params => ({
    method: 'PATCH',
    uri: ['settings/payment_processors/enable', params].join('/')
  }),
  disActivateStripeAccount: params => ({
    method: 'PATCH',
    uri: ['settings/payment_processors/disable', params].join('/')
  }),
  getPaymentProcessors: {
    method: 'GET',
    uri: 'settings/payment_processors'
  },
  domains: {
    method: 'GET',
    uri: 'settings/payment_processors/domains'
  }
};
let IdentityVerification = {
  // leave params here see IdentityVerification page
  createVerificationInfo: (data, params, query) => ({
    method: 'POST',
    uri: ['settings/identity_verification', query].join(''),
    data,
    contentType: 'form-data'
  }),
  saveVerificationInfo: (data, params, query) => ({
    method: 'PUT',
    uri: ['settings/identity_verification/', params, query].join(''),
    data,
    contentType: 'form-data'
  }),
  getUserIdVerification: query => ({
    method: 'GET',
    uri: ['settings/identity_verification', query].join('')
  })
};
let UserVerifications = {
  getUserVerifications: (data, query) => ({
    method: 'POST',
    uri: ['user/identity_verification', query].join(''),
    data
  }),
  verifyUserIdentity: (data, params, query) => ({
    method: 'POST',
    uri: ['user/identity_verification/verify/', params, query].join(''),
    data
  })
};
let UserSettings = {
  saveUser: data => {
    return {
      method: 'PUT',
      uri: 'user/save/account',
      data
    };
  },
  saveTrackingConfiguration(data) {
    return {
      method: 'POST',
      uri: 'user-save-tracking-info',
      data
    };
  },
  requestEmailVerification: {
    method: 'GET',
    uri: 'request-email-verification'
  },
  changeSubscriptionPlan: planName => ({
    method: 'GET',
    uri: ['user/change-plan/', planName].join('')
  })
};
let ActivityLogsPageApi = {
  getFilteredActivities(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['activity/filter', query].join(''),
      data
    };
  }
};
let AuthenticationApi = {
  logout: {
    method: 'GET',
    uri: 'logout'
  },
  login: data => ({
    method: 'POST',
    uri: "login",
    data
  }),
  register: data => ({
    method: 'POST',
    uri: "register",
    data
  }),
  checkAuth: {
    method: 'GET',
    uri: 'check'
  },
  asyncCheckAuth: data_model => ({
    method: 'GET',
    uri: 'check',
    isAsync: true,
    data_model
  }),
  checkEmail: (query, data_model) => ({
    method: 'GET',
    uri: ['check', query].join(''),
    isAsync: true,
    data_model
  }),
  checkInstagramLink: {
    method: 'GET',
    uri: 'instagram-auth-link'
  },
  emailVerification: params => ({
    method: 'GET',
    uri: ['email-verification/', params].join('')
  })
};
let TutorialPage = {
  getCategories: {
    method: 'GET',
    uri: 'category/light'
  },
  getTutorialCategories(query) {
    return {
      method: 'GET',
      uri: ['category', query].join('')
    };
  },
  deleteCategory: (params, query = '?show=10') => {
    return {
      method: 'DELETE',
      uri: ['category/', params, query].join('')
    };
  },
  saveCategory: (params, data) => {
    return {
      method: 'PUT',
      uri: ['category/', params].join(''),
      data
    };
  },
  deleteTutorial: params => {
    return {
      method: 'DELETE',
      uri: ['tutorial/', params].join('')
    };
  },
  createTutorial: data => {
    return {
      method: 'POST',
      uri: 'tutorial',
      data
    };
  },
  duplicateTutorial: (params, query = '?show=10') => {
    return {
      method: 'GET',
      uri: ['duplicate-tutorial/', params, query].join('')
    };
  },
  updateTutorial: (params, data) => {
    return {
      method: 'PUT',
      uri: ['tutorial/', params].join(''),
      data
    };
  },
  publishCategory: params => {
    return {
      method: 'GET',
      uri: ['category/publish/', params].join('')
    };
  }
};
let TicketPage = {
  getLightUsers: {
    method: 'GET',
    uri: 'ticket/filter/users'
  },
  getFilteredTicket(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['ticket/filter', query].join(''),
      data
    };
  },
  createTicket(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['ticket/form', query].join(''),
      data
    };
  },
  sendTicketMessage(params, data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['ticket/ticket_message/', params, query].join(''),
      data
    };
  },
  closeTicket(params, data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['ticket/close_ticket/', params, query].join(''),
      data
    };
  }
};
let FaqPage = {
  getCategories: {
    method: 'GET',
    uri: 'faq/category/light'
  },
  getFilteredCategories(query = '?show=10') {
    return {
      method: 'GET',
      uri: ['faq/category/filter', query].join('')
    };
  },
  createFaq(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['faq', query].join(''),
      data
    };
  },
  updateFaq(params, data, query = '?show=10') {
    return {
      method: 'PUT',
      uri: ['faq/', params, query].join(''),
      data
    };
  },
  deleteFaqCategory(params, query = '?show=10') {
    return {
      method: 'DELETE',
      uri: ['faq/category/', params, query].join('')
    };
  },
  deleteFaq(params, query = '?show=10') {
    return {
      method: 'DELETE',
      uri: ['faq/', params, query].join('')
    };
  },
  updateFaqCategory(params, data, query = '?show=10') {
    return {
      method: 'PUT',
      uri: ['faq/category/', params, query].join(''),
      data
    };
  },
  publishFaqCategory(params, query = '?show=10') {
    return {
      method: 'PATCH',
      uri: ['faq/category/publish/', params, query].join('')
    };
  }
};
let PreSellPagePageApi = {
  getFilterOffers: {
    method: 'GET',
    uri: 'pre-sell-page-filter-offers'
  },
  getFilterUsers: {
    method: 'GET',
    uri: 'pre-sell-page-filter-users'
  },
  createPreSellPage: (data, query = '?show=10') => ({
    method: 'POST',
    uri: ['pre-sell-page', query].join(''),
    data
  })
};
let ProtoPreSellPagePageApi = {
  getFormSalePages: {
    method: 'GET',
    uri: 'pre-sell-page-form-proto-sale-pages'
  },
  getFormDomains: {
    method: 'GET',
    uri: 'proto-pre-sell-page-form-domains'
  },
  updatePreSellPage: (data, params, query = '?show=10') => ({
    method: 'PUT',
    uri: ['proto-pre-sell-page/', params, query].join(''),
    data
  }),
  filterPreSellPage: (data, query) => ({
    method: 'POST',
    uri: ['filter-proto-pre-sell-page', query].join(''),
    data
  }),
  deletePreSellPage: (data, params, query) => ({
    method: 'DELETE',
    uri: ['proto-pre-sell-page/', params, query].join(''),
    data
  }),
  duplicatePreSellPagePage(data, params, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['duplicate-proto-pre-sell-page/', params, query].join(''),
      data
    };
  }
};
let InstancePreSellPagePageApi = {
  getFormSalePages: {
    method: 'GET',
    uri: 'pre-sell-page-form-instance-sale-pages'
  },
  getFormDomains: {
    method: 'GET',
    uri: 'instance-pre-sell-page-form-domains'
  },
  updatePreSellPage: (data, params, query) => ({
    method: 'PUT',
    uri: ['instance-pre-sell-page/', params, query].join(''),
    data
  }),
  filterPreSellPage: (data, query) => ({
    method: 'POST',
    uri: ['filter-instance-pre-sell-page', query].join(''),
    data
  }),
  deletePreSellPage: (data, params, query) => ({
    method: 'DELETE',
    uri: ['instance-pre-sell-page/', params, query].join(''),
    data
  }),
  duplicatePreSellPagePage(data, params, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['duplicate-instance-pre-sell-page/', params, query].join(''),
      data
    };
  }
};
let BusinessManagersPage = {
  productMap: (data, params, query) => ({
    method: 'POST',
    uri: ['business_manager/woo_commerce/product_mapping/', params, query].join(''),
    data
  }),
  productVariationMap: (data, params, query) => ({
    method: 'POST',
    uri: ['business_manager/woo_commerce/product_variation_mapping/', params, query].join(''),
    data
  }),
  getOffersForMapping: (data, query = '?show=10') => ({
    method: 'POST',
    uri: ['business_manager/woo_commerce/offer_list', query].join(''),
    data
  }),
  getOfferVariationsForMapping: (params, query = '?show=10') => ({
    method: 'GET',
    uri: ['business_manager/woo_commerce/product_variation_list/', params, query].join('')
  }),
  getWooCommerceProducts: (params, query = '?show=10') => ({
    method: 'GET',
    uri: ['business_manager/woo_commerce/product_list/', params, query].join('')
  }),
  getWooCommerceVariations: (params, query = '?show=10') => ({
    method: 'GET',
    uri: ['business_manager/woo_commerce/product_variations_list/', params, query].join('')
  }),
  addStoreDomain: (data, params, query = '?show=10') => {
    return {
      method: 'POST',
      uri: ['business_manager/woo_commerce/add_business_manager_store_domain/', params, query].join(''),
      data
    };
  },
  getStoreDomains: (params, query = '?show=10') => {
    return {
      method: 'POST',
      uri: ['business_manager/woo_commerce/get_business_manager_store_domain/', params, query].join('')
    };
  },
  enableStoreDomain(params, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['business_manager/woo_commerce/enable_store_domain/', params, query].join('')
    };
  },
  disableStoreDomain(params, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['business_manager/woo_commerce/disable_store_domain/', params, query].join('')
    };
  },
  deleteStoreDomain(params, query = '?show=10') {
    return {
      method: 'DELETE',
      uri: ['business_manager/woo_commerce/delete_store_domain/', params, query].join('')
    };
  },
  syncDataFromStore: (params, query = '?show=10') => ({
    method: 'GET',
    uri: ['business_manager/woo_commerce/sync_data_from_store/', params, query].join('')
  }),
  dontSyncDataFromStore: (params, query = '?show=10') => ({
    method: 'GET',
    uri: ['business_manager/woo_commerce/dont_sync_data_from_store/', params, query].join('')
  })
};
let FeedFormPage = {
  getCountries: {
    method: 'GET',
    uri: 'business_manager/product_feed_form_light_countries'
  },
  getDomainsGoogle: {
    method: 'GET',
    uri: 'business_manager/google/product_feed_form_light_domains'
  },
  getDomainsFacebook: {
    method: 'GET',
    uri: 'business_manager/facebook/product_feed_form_light_domains'
  },
  generateGoogleFeed: (data, query = '?show=10') => ({
    method: 'POST',
    uri: ['business_manager/google/create_product_feed', query].join(''),
    data
  }),
  generateFacebookFeed: (data, query = '?show=10') => ({
    method: 'POST',
    uri: ['business_manager/facebook/create_product_feed', query].join(''),
    data
  }),
  getGoogleProductFeeds: (query = '?show=10') => ({
    method: 'GET',
    uri: ['business_manager/google/product_feeds', query].join('')
  }),
  getFacebookProductFeeds: (query = '?show=10') => ({
    method: 'GET',
    uri: ['business_manager/facebook/product_feeds', query].join('')
  }),
  saveDomainGoogleVerificationString: data => ({
    method: 'POST',
    uri: 'business_manager/google/save_domain_verification_string',
    data
  }),
  saveDomainFacebookVerificationString: data => ({
    method: 'POST',
    uri: 'business_manager/facebook/save_domain_verification_string',
    data
  }),
  deleteGoogleFeed: (feed_id, query = '?show=10') => ({
    method: 'DELETE',
    uri: ['business_manager/google/delete_feed/', feed_id, query].join('')
  }),
  deleteFacebookFeed: (feed_id, query = '?show=10') => ({
    method: 'DELETE',
    uri: ['business_manager/facebook/delete_feed/', feed_id, query].join('')
  }),
  refreshGoogleFeedProducts: (feed_id, query = '?show=10') => ({
    method: 'GET',
    uri: ['business_manager/google/refresh_feed_products/', feed_id, query].join('')
  }),
  refreshFacebookFeedProducts: (feed_id, query = '?show=10') => ({
    method: 'GET',
    uri: ['business_manager/facebook/refresh_feed_products/', feed_id, query].join('')
  }),
  getFeedProducts: (feed_id, query = '?show=10') => ({
    method: 'GET',
    uri: ['business_manager/feed_products/', feed_id, query].join('')
  }),
  getFeedProductLightSalePages: (feed_product_id, query = '?show=10') => ({
    method: 'GET',
    uri: ['business_manager/feed_product_sale_pages/', feed_product_id].join('')
  }),
  saveGoogleFeedProducts: (data, feed_id, query = '?show=10') => ({
    method: 'POST',
    uri: ['business_manager/google/save_feed_products/', feed_id, query].join(''),
    data
  }),
  saveFacebookFeedProducts: (data, feed_id, query = '?show=10') => ({
    method: 'POST',
    uri: ['business_manager/facebook/save_feed_products/', feed_id, query].join(''),
    data
  })
};
let ReferralProgram = {
  referredStats: {
    method: 'GET',
    uri: 'referral_program/link/user_referred_stats'
  },
  getCountries: {
    method: 'GET',
    uri: 'referral_program/link/countries'
  },
  getReferrers: {
    method: 'GET',
    uri: 'referral_program/link/referrers'
  },
  getFilteredReferred: (query = '?show=10') => ({
    method: 'GET',
    uri: ['referral_program/link/referred', query].join('')
  }),
  getFilteredInvoices: (query = '?show=10') => ({
    method: 'GET',
    uri: ['referral_program/invoices', query].join('')
  }),
  getFilteredPayoutInvoices: (query = '?show=10') => ({
    method: 'GET',
    uri: ['referral_program/payouts', query].join('')
  }),
  createPayoutInvoices: (data, query) => ({
    method: 'POST',
    uri: ['referral_program/invoices/generate', query].join(''),
    data
  }),
  deletePayoutInvoice: (invoiceId, query = '?show=10') => ({
    method: 'DELETE',
    uri: ['referral_program/payouts/', invoiceId, query].join('')
  }),
  payReferrerInvoices: (data, query) => ({
    method: 'POST',
    uri: ['referral_program/payouts/pay', query].join(''),
    data
  }),
  thisMonthTotalPaidEarning: {
    method: 'GET',
    uri: 'referral_program/payouts/total_paid_earnings/this_month'
  },
  lastMonthTotalPaidEarning: {
    method: 'GET',
    uri: 'referral_program/payouts/total_paid_earnings/last_month'
  },
  thisYearTotalPaidEarning: {
    method: 'GET',
    uri: 'referral_program/payouts/total_paid_earnings/this_year'
  },
  lastYearTotalPaidEarning: {
    method: 'GET',
    uri: 'referral_program/payouts/total_paid_earnings/last_year'
  },
  filterUsers: {
    method: 'GET',
    uri: 'referral_program/payouts/filter/users'
  },
  referralInvoicesReferrers: {
    method: 'GET',
    uri: 'referral_program/invoices/filter/referrers'
  },
  referralInvoicesGeneratedFor: {
    method: 'GET',
    uri: 'referral_program/invoices/filter/generated_for'
  },
  savePaymentMethod: data => ({
    method: 'POST',
    uri: 'referral_program/payouts/save_payment_method',
    data
  }),
  getReferrerReferredInvoices(params, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['referral_program/payouts/referral_invoices/', params, query].join('')
    };
  }
};
let SubscriptionInvoices = {
  getFilterUsers: {
    method: 'GET',
    uri: 'invoice/subscription/filter/users'
  },
  getFilteredInvoices: query => ({
    method: 'GET',
    uri: ['invoice/subscription/filtered', query].join('')
  }),
  payInvoice: (params, query) => ({
    method: 'PATCH',
    uri: ['invoice/subscription/pay-invoice/', params, query].join('')
  }),
  changePaymentMethod: {
    method: 'PATCH',
    uri: 'invoice/subscription/change-payment-method'
  }
};
let ReferralInvoices = {
  getFilteredReferralInvoices: (data, query = '?show=10') => ({
    method: 'POST',
    uri: ['referral-invoices', query].join(''),
    data
  }),
  generateReferralInvoices: (data, query = '?show=10') => ({
    method: 'POST',
    uri: ['generate-referral-invoices', query].join(''),
    data
  }),
  getReferrerInvoices(params, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['referral-invoices/', params, query].join('')
    };
  }
};
let OfferRequestPage = {
  getOfferRequestLightOffers: {
    method: 'GET',
    uri: 'offer-request-light-offers'
  },
  getOfferRequestLightUsers: {
    method: 'GET',
    uri: 'offer-request-light-users'
  },
  updateClient(data, params, query = '?show=10') {
    return {
      method: 'PUT',
      uri: ['client/', params, query].join(''),
      data
    };
  },
  deleteClient(params, query = '?show=10') {
    return {
      method: 'DELETE',
      uri: ['client/', params, query].join('')
    };
  },
  getFilteredOfferReviews(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['offer-request-filter', query].join(''),
      data
    };
  },
  requestOfferReview(data, params, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['offer-request/', params, query].join(''),
      data
    };
  },
  changeOfferRequestStatusStatus(data, query = '?show=10') {
    return {
      method: 'POST',
      uri: ['offer-request-status', query].join(''),
      data
    };
  },
  getOfferRequestLightOffer(query = '?show=10') {
    return {
      method: 'GET',
      uri: ['offer-request-light-offers', query].join('')
    };
  },
  getOfferRequestLightUser(query = '?show=10') {
    return {
      method: 'GET',
      uri: ['offer-request-light-users', query].join('')
    };
  },
  deleteOfferRequest(data, params, query = '?show=10') {
    return {
      method: 'DELETE',
      uri: ['offer-request-delete/', params, query].join(''),
      data
    };
  },
  getOfferRequestFormCountries: {
    method: 'GET',
    uri: 'offer-request-form-countries'
  }
};
let PasswordRequestPage = {
  passwordRequest(data) {
    return {
      method: 'POST',
      uri: "request-password",
      data
    };
  }
};
let PasswordResetPage = {
  passwordReset: (params, data) => ({
    method: 'POST',
    uri: ["reset-password", params].join('/'),
    data
  })
};
let InstagramVerificationPage = {
  verifyInstagramLink: query => ({
    method: 'GET',
    uri: ['instagram-verify', query].join('')
  })
};
let StorePagePage = {
  getFilteredStorePages: query => ({
    method: 'GET',
    uri: ['store/pages', Array.isArray(query) ? query.join('&') : query].join('')
  }),
  getFilterStores: {
    method: 'GET',
    uri: 'store/pages/filter/stores'
  },
  getStorePage: pageId => ({
    method: 'GET',
    uri: ['store/pages', pageId].join('/')
  }),
  getFormStores: {
    method: 'GET',
    uri: 'store/pages/form/stores'
  },
  saveStorePage: (data, params, query) => ({
    method: 'PUT',
    uri: ['store/pages/', params, query].join(''),
    data
  }),
  deleteStorePage: (params, query) => ({
    method: 'DELETE',
    uri: ['store/pages/', params, query].join('')
  })
};
let StoreSettingPage = {
  addStripeAccount: data => ({
    method: 'POST',
    uri: 'settings/payment_processors/',
    data
  }),
  filteredStores: query => ({
    method: 'GET',
    uri: ['store/settings/filtered', query].join('')
  }),
  getStore: params => ({
    method: 'GET',
    uri: ['store/settings/form/', params].join('')
  }),
  updateStore: (params, data, query = '?show=10') => ({
    method: 'PUT',
    uri: ['store/settings/form/', params, query].join(''),
    data
  }),
  createStore: (data, query = '?show=10') => ({
    method: 'POST',
    uri: ['store/settings/form', query].join(''),
    data
  }),
  deleteStore: (storeId, query) => ({
    method: 'DELETE',
    uri: ['store/settings/form/', storeId, query].join('')
  }),
  filterDomains: {
    method: 'GET',
    uri: 'store/settings/filter/domains'
  },
  storeLayout: layoutId => ({
    method: 'GET',
    uri: ['store/settings/form/layout', layoutId].join('/')
  }),
  storeLayouts: {
    method: 'GET',
    uri: 'store/settings/form/layouts/list'
  },
  activateStore: storeId => ({
    method: 'GET',
    uri: ['store/settings/activate', storeId].join('/')
  }),
  inactivateStore: storeId => ({
    method: 'GET',
    uri: ['store/settings/inactivate', storeId].join('/')
  }),
  formDomains: {
    method: 'GET',
    uri: 'store/settings/form/domains/list'
  }
};
let StoreLayoutPage = {
  createLayout: (data, query = '?show=10') => ({
    method: 'POST',
    uri: ['store/layout', query].join(''),
    data
  }),
  updateLayout: (params, data, query = '?show=10') => ({
    method: 'PUT',
    uri: ['store/layout/', params, query].join(''),
    data
  }),
  filteredLayouts: query => ({
    method: 'GET',
    uri: ['store/layout/filtered', query].join('')
  }),
  duplicateLayout: (params, query) => ({
    method: 'GET',
    uri: ['store/layout/duplicate/', params, query].join('')
  }),
  deleteLayout: (params, query) => ({
    method: 'DELETE',
    uri: ['store/layout/', params, query].join('')
  }),
  getLayout: params => ({
    method: 'GET',
    uri: ['store/layout/', params].join('')
  })
};
let PageBuilder = {
  getDomainPagesBlockOffers: params => ({
    method: 'GET',
    uri: ['page-builder', 'domain-offers-block', params, 'offers'].join('/')
  }),
  getDomainPagesBlockProducts: params => ({
    method: 'GET',
    uri: ['page-builder', 'domain-product-block', params, 'products'].join('/')
  }),
  getDomainPagesBlockPages: params => ({
    method: 'GET',
    uri: ['page-builder', 'brand-domain-block', params, 'sale_pages'].join('/')
  })
};
let NetworkSdkAccountsPage = {
  getFilteredAccounts: query => ({
    method: 'GET',
    uri: 'network_sdk_account/filtered' + query
  }),
  getWarehouseAccounts: {
    method: 'GET',
    uri: 'network_sdk_account/accounts/warehouse'
  },
  getAccounts: {
    method: 'GET',
    uri: 'network_sdk_account/accounts'
  },
  create: (data, query) => ({
    method: 'POST',
    uri: ['network_sdk_account', query].join(''),
    data
  }),
  save: (data, params, query) => ({
    method: 'PUT',
    uri: ['network_sdk_account/', params, query].join(''),
    data
  }),
  delete: (params, query) => ({
    method: 'DELETE',
    uri: ['network_sdk_account/', params, query].join('')
  }),
  getECommerceSdks: {
    method: 'GET',
    uri: 'network_sdk_account/ecommerce_sdks'
  }
};
const GoogleSheetPage = {
  getFilteredSheets: (data, query) => ({
    method: 'GET',
    uri: 'business_manager/google_sheet'
  }),
  createSheet: (data, query) => ({
    method: 'POST',
    uri: ['business_manager/google_sheet', query].join(''),
    data
  }),
  saveSheet: (data, sheetId, query) => ({
    method: 'PUT',
    uri: ['business_manager/google_sheet/', sheetId, query].join(''),
    data
  }),
  deleteSheet: (data, sheetId, query) => ({
    method: 'DELETE',
    uri: ['business_manager/google_sheet/', sheetId, query].join(''),
    data
  }),
  fromWarehouses: {
    method: 'GET',
    uri: 'business_manager/google_sheet/form/from_warehouses'
  },
  fromProducts: {
    method: 'GET',
    uri: 'business_manager/google_sheet/form/from_products'
  },
  fromStores: {
    method: 'GET',
    uri: 'business_manager/google_sheet/form/from_stores'
  },
  fromSalePages: {
    method: 'GET',
    uri: 'business_manager/google_sheet/form/from_sale_pages'
  }
};
export { GoogleSheetPage, NetworkSdkAccountsPage, PageBuilder, StorePagePage, StoreSettingPage, StoreLayoutPage, InstagramVerificationPage, PasswordResetPage, PasswordRequestPage, OfferRequestPage, ReferralInvoices, SubscriptionInvoices, ReferralProgram, UserVerifications, IdentityVerification, FeedFormPage, BusinessManagersPage, PaymentProcessorsSettings, SalePageProtoApi, ProductSalePageApi, SalePageInstanceApi, CodOfferApi, PrepaidOfferApi, PreSellPagePageApi, ProtoPreSellPagePageApi, InstancePreSellPagePageApi, FaqPage, TicketPage, TutorialPage, AuthenticationApi, GlobalApis, ActivityLogsPageApi, CommissionInvoicesPageApi, UserSettings, InvoicePageApi, PaymentSettings, PayoutInvoicesPageApi, NotificationPageApi, ExpensesInvoicesPageApi, RemittanceInvoicesPageApi, DomainPageApi, AccountingPageApi, SellerPageApi, SaleReportPageApi, AdvertiserPageApi, CallCenterPageApi, RegisterPageApi, SettingsPageApi, ProductPageApi, OfferPageApi, UsersPageApi, WarehousePageApi, SalePagePageApi, LeadPageApi, InventoryOverViewPageApi, TestedOrdersPageApi, OrderPageApi, PendingOrdersPageApi, LibraryPageApi, OverViewPageApi, TrendingPageApi, HomePageApi, ExternalRequestsApi };